// Position-detail body block types
export const CONTENT_BLOCK_TYPE = {
  LEVEL_1: 'LEVEL_1', // heading level 1
  LEVEL_2: 'LEVEL_2', // heading level 2
  PARAGRAPH: 'PARAGRAPH', // body paragraph
};

// Backend block type to BEM modifier (see SectionContent in job.js)
export const BLOCK_MODIFIER = {
  [CONTENT_BLOCK_TYPE.LEVEL_1]: 'level1',
  [CONTENT_BLOCK_TYPE.LEVEL_2]: 'level2',
  [CONTENT_BLOCK_TYPE.PARAGRAPH]: 'paragraph',
};

// Allowed resume extensions: PDF / Word / Excel / PNG / JPEG.
export const ACCEPT_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.png',
  '.jpg',
  '.jpeg',
];

export const ACCEPT_MIME_TYPES = [
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'image/*', // .png / .jpg / .jpeg
];

export const ACCEPT_ATTR = [...ACCEPT_EXTENSIONS, ...ACCEPT_MIME_TYPES].join(
  ','
);

// Caps: 5MB per file, 15MB total (decimal MB, matching the backend)
export const MAX_FILE_MB = 5;
export const MAX_TOTAL_MB = 15;
// Bytes per decimal MB (1000*1000), matching the backend's size math
export const BYTES_PER_MB = 1000 * 1000;

// Idle pause (ms) before the hero video loops (top.js)
export const SCAN_IDLE_MS = 2000;

// List endpoint is unpaged: fetch all at once, "show more" client-side
export const FETCH_ALL_PAGE_SIZE = 999;
// First page index for the paginated list endpoint
export const FIRST_PAGE = 1;

// Collapsed job-list size before "show more" (fewer on mobile)
export const COLLAPSED_JOBS_MOBILE = 5;
export const COLLAPSED_JOBS_DESKTOP = 10;

// Mobile breakpoint in px (matches the LESS breakpoint in vars.less)
export const MOBILE_BREAKPOINT_PX = 767;

// Sentinel id for the "All" filter tab (never collides with a real type id)
export const ALL_FILTER_ID = -1;
